import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DeleteConfirmation from './DeleteConfirmation';
import HideConfirmation from './HideConfirmation';

function Modal() {
    const [visible, setVisible] = useState(false);

    const activeModal = useSelector((state) => state.collections.modal.activeModal);
    const displayModal = useSelector((state) => state.collections.modal.displayModal);

    useEffect(() => {
        if(displayModal) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [displayModal]);

    return (
        <div className={`${visible ? 'opacity-100 visible bg-[#00000080]' : 'opacity-0 invisible'} transition-all duration-100 ease-in-out fixed z-50 w-full h-full top-0 left-0 flex justify-center items-center`}>
            {activeModal === 'delete-confirm' && <DeleteConfirmation />}

            {activeModal === 'hide-confirm' && <HideConfirmation />}
        </div>
    )
}

export default Modal;
